import { Routes } from '@angular/router';
import { Landing } from './auth/landing/landing';
import { authGuard } from '../core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: Landing,
    children: [
      {
        path: '',
        loadComponent: () => import('./auth/login/login').then((m) => m.Login),
      },
    ],
  },
  {
    path: 'home',
    canActivate: [authGuard],
    loadChildren: () => import('./main/main.routes').then((m) => m.routes),
  },

  // {
  //   path: '',
  //   redirectTo: 'login',
  //   pathMatch: 'full',
  // },
  // {
  //   path: '',
  //   component: Landing,
  //   children: [
  //     {
  //       path: 'login',
  //       loadComponent: () => import('./auth/login/login').then((m) => m.Login),
  //     },
  //   ],
  // },
  // {
  //   path: 'home',
  //   canActivate: [authGuard],
  //   loadChildren: () => import('./main/main.routes').then((m) => m.routes),
  // },
];
